export const GET_APPOINTMENTS_LIST = null;
export const SELECTED_APPOINTMENTS_ID = null;
export const SELECTED_SUPER_ADMIN_SERVICE_ID_FOR_PACKAGE = null;